import React, { useState } from "react";
import { useTheme } from "../../components/header/header";
import "./input.css";

import password from "./img/password.svg";
import passwordDark from "./img/password-dark.svg";
import show from "./img/show.svg";
import showDark from "./img/show-dark.svg";
import errorIcon from "./img/error.svg";

const Input = ({
  label,
  type = "text",
  id,
  value,
  onChange,
  validate,
  optional = false,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [touched, setTouched] = useState(false);
  const { theme } = useTheme();

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    onChange(inputValue);
    setError(null);
  };

  const handleBlur = () => {
    setTouched(true);
    if (!optional || value.trim()) {
      const errorMessage = validate(value);
      setError(errorMessage);
    }
  };

  return (
    <div className="inputWrap">
      <label htmlFor={id} className="label">
        {label}
      </label>
      {type === "password" && (
        <div className="passwordWrap">
          <input
            type={showPassword ? "text" : "password"}
            id={id}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            className={"input"}
            {...rest}
          />
          {(touched && error) && (
            <div className="errorWrap">
              <img className="errorIcon" src={errorIcon} alt="Error" />
              <span className="errorMessage">{error}</span>
            </div>
          )}
          <img
            className="passwordIcon"
            src={
              theme === "light"
                ? showPassword
                  ? show
                  : password
                : showPassword
                ? showDark
                : passwordDark
            }
            alt={showPassword ? "Hide password" : "Show password"}
            onClick={togglePasswordVisibility}
            style={{ cursor: "pointer" }}
          />
        </div>
      )}
      {type !== "password" && (
        <div className="inputErrorWrap">
          <input
            type={type}
            id={id}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            className={"input"}
            {...rest}
          />
          {(touched && error) && (
            <div className="errorWrap">
              <img className="errorIcon" src={errorIcon} alt="Error" />
              <span className="errorMessage">{error}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Input;